import { Component, input, output, ViewEncapsulation } from '@angular/core';

export interface ModalProps {
  exito?: boolean;
  texto?: string;
}

@Component({
  selector: 'app-modal',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  template: `
    @if (mostrar()) {
      <div class="prefixCot">
        <div class="modal fade in" tabindex="-1" style="display: block;" role="dialog">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
                
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  (click)="closeModal()"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <div class="row">
                  @if (propsModal()?.exito) {
                    <div class="col-md-2 col-sm-2 col-xs-2 col-lg-2">
                      <div class="imageExitoCot"></div>
                    </div>
                  } @else {
                    <div class="col-md-2 col-sm-2 col-xs-2 col-lg-2">
                      <div class="imageErrorCot"></div>
                    </div>
                  }

                  <div class="col-md-10 col-sm-10 col-xs-10 col-lg-10 text-justify">
                    <p>{{ propsModal()?.texto }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-backdrop fade in"></div>
      </div>
    }
  `
})
export class ModalComponent {
  mostrar = input<boolean>(false);
  propsModal = input<ModalProps | null>(null);
  onCerrar = output<void>();

  closeModal(): void {
    this.onCerrar.emit();
  }
}